(() => {
  const mobileQuery = window.matchMedia('(max-width: 1023px)');

  function initializeKhpetMobileNav() {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.site-header-menu-toggle');
    const mobileNav = document.querySelector('.site-mobile-nav');
    const closeButton = document.querySelector('.mobile-nav-close');
    const overlay = document.querySelector('.mobile-nav-overlay');

    if (!header || !toggle || !mobileNav) {
      console.warn('KH Pet mobile navigation elements were not found.');
      return;
    }

    if (toggle.dataset.khpetMobileInitialized === 'true') {
      return;
    }

    toggle.dataset.khpetMobileInitialized = 'true';

    function menuIsOpen() {
      return header.classList.contains('khpet-mobile-nav-open');
    }

    function closeSubmenus() {
      mobileNav
        .querySelectorAll('.khpet-submenu-open')
        .forEach(item => {
          item.classList.remove('khpet-submenu-open');

          const button = item.querySelector(':scope > .navmenu-button');
          const link = item.querySelector(':scope > .navmenu-link-parent');

          button?.setAttribute('aria-expanded', 'false');
          link?.setAttribute('aria-expanded', 'false');
        });
    }

    function openMenu() {
      if (!mobileQuery.matches) {
        return;
      }

      header.classList.add('khpet-mobile-nav-open');
      header.classList.remove('site-header-nav--open');

      document.body.classList.add('scroll-lock');

      toggle.setAttribute('aria-expanded', 'true');
      mobileNav.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
      header.classList.remove('khpet-mobile-nav-open');

      document.body.classList.remove('scroll-lock');

      toggle.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');

      closeSubmenus();

      if (mobileQuery.matches) {
        header.classList.remove('site-header-nav--open');
      } else {
        header.classList.add('site-header-nav--open');
      }
    }

    function syncNavigationForViewport() {
      closeMenu();

      if (mobileQuery.matches) {
        header.classList.remove('site-header-nav--open');
      } else {
        header.classList.add('site-header-nav--open');
      }
    }

    toggle.addEventListener(
      'click',
      event => {
        if (!mobileQuery.matches) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        menuIsOpen() ? closeMenu() : openMenu();
      },
      true
    );

    closeButton?.addEventListener(
      'click',
      event => {
        if (!mobileQuery.matches) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        closeMenu();
        toggle.focus();
      },
      true
    );

    overlay?.addEventListener(
      'click',
      event => {
        if (!mobileQuery.matches) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        closeMenu();
        toggle.focus();
      },
      true
    );

    mobileNav.addEventListener(
  'click',
  event => {
    const button = event.target.closest('.navmenu-button');

    if (!button || !mobileQuery.matches) {
      return;
    }

    const item = button.closest('.navmenu-item-parent');
    const submenu = item?.querySelector(
      ':scope > .navmenu-submenu'
    );
    const link = item?.querySelector(
      ':scope > .navmenu-link-parent'
    );

    if (!item || !submenu) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const opening =
      !item.classList.contains('khpet-submenu-open');

    /*
     * Close every other open submenu first.
     */
    mobileNav
      .querySelectorAll(
        '.navmenu-item-parent.khpet-submenu-open'
      )
      .forEach(openItem => {
        if (openItem === item) {
          return;
        }

        openItem.classList.remove('khpet-submenu-open');

        const openButton = openItem.querySelector(
          ':scope > .navmenu-button'
        );
        const openLink = openItem.querySelector(
          ':scope > .navmenu-link-parent'
        );

        openButton?.setAttribute('aria-expanded', 'false');
        openLink?.setAttribute('aria-expanded', 'false');
      });

    item.classList.toggle(
      'khpet-submenu-open',
      opening
    );

    button.setAttribute(
      'aria-expanded',
      String(opening)
    );

    link?.setAttribute(
      'aria-expanded',
      String(opening)
    );
  },
  true
);

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menuIsOpen()) {
        closeMenu();
        toggle.focus();
      }
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener(
        'change',
        syncNavigationForViewport
      );
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncNavigationForViewport);
    }

    syncNavigationForViewport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeKhpetMobileNav
    );
  } else {
    initializeKhpetMobileNav();
  }
})();